export const DESIGN_TOKEN_TEXT = {
  heading28Bold: {
    fontSize: "2.8rem",
    fontWeight: "700",
    lineHeight: "150%",
  },
  heading24Bold: {
    fontSize: "2.4rem",
    fontWeight: "700",
    lineHeight: "150%",
  },
  title22Bold: {
    fontSize: "2.2rem",
    fontWeight: "700",
    lineHeight: "150%",
  },
  title20Bold: {
    fontSize: "2.0rem",
    fontWeight: "600",
    lineHeight: "140%",
  },
  title20Bold2: {
    fontSize: "2.0rem",
    fontWeight: "700",
    lineHeight: "140%",
  },
  title18Bold: {
    fontSize: "1.8rem",
    fontWeight: "600",
    lineHeight: "140%",
  },
  title16Strong: {
    fontSize: "1.6rem",
    fontWeight: "700",
    lineHeight: "150%",
  },
  title16Bold: {
    fontSize: "1.6rem",
    fontWeight: "600",
    lineHeight: "140%",
  },
  subtitle18SemiBold: {
    fontSize: "1.8rem",
    fontWeight: "500",
    lineHeight: "140%",
  },
  subtitle16SemiBold: {
    fontSize: "1.6rem",
    fontWeight: "500",
    lineHeight: "140%",
  },
  subtitle14Strong: {
    fontSize: "1.4rem",
    fontWeight: "700",
    lineHeight: "140%",
  },
  subtitle14Bold: {
    fontSize: "1.4rem",
    fontWeight: "600",
    lineHeight: "140%",
  },
  subtitle14SemiBold: {
    fontSize: "1.4rem",
    fontWeight: "500",
    lineHeight: "140%",
  },
  body16Medium: {
    fontSize: "1.6rem",
    fontWeight: "400",
    lineHeight: "140%",
  },
  body15Bold: {
    fontSize: "1.5rem",
    fontWeight: "700",
    lineHeight: "140%",
  },
  body15Normal: {
    fontSize: "1.5rem",
    fontWeight: "600",
    lineHeight: "140%",
  },
  body15SemiBold: {
    fontSize: "1.5rem",
    fontWeight: "500",
    lineHeight: "140%",
  },
  body15Medium: {
    fontSize: "1.5rem",
    fontWeight: "400",
    lineHeight: "140%",
  },
  body14Strong: {
    fontSize: "1.4rem",
    fontWeight: "700",
    lineHeight: "150%",
  },
  body14Bold: {
    fontSize: "1.4rem",
    fontWeight: "600",
    lineHeight: "150%",
  },
  body14SemiBold: {
    fontSize: "1.4rem",
    fontWeight: "500",
    lineHeight: "140%",
  },
  body14Medium: {
    fontSize: "1.4rem",
    fontWeight: "400",
    lineHeight: "140%",
  },
  body13Bold: {
    fontSize: "1.3rem",
    fontWeight: "600",
    lineHeight: "150%",
  },
  body13Medium: {
    fontSize: "1.3rem",
    fontWeight: "400",
    lineHeight: "140%",
  },
  body12Strong: {
    fontSize: "1.2rem",
    fontWeight: "600",
    lineHeight: "140%",
  },
  body12Bold: {
    fontSize: "1.2rem",
    fontWeight: "600",
    lineHeight: "140%",
  },
  body12SemiBold: {
    fontSize: "1.2rem",
    fontWeight: "500",
    lineHeight: "140%",
  },
  body11SemiBold: {
    fontSize: "1.1rem",
    fontWeight: "500",
    lineHeight: "140%",
  },
  body12Medium: {
    fontSize: "1.2rem",
    fontWeight: "400",
    lineHeight: "140%",
  },
  caption11Medium: {
    fontSize: "1.1rem",
    fontWeight: "400",
    lineHeight: "140%",
  },
  caption10Bold: {
    fontSize: "1rem",
    fontWeight: "600",
    lineHeight: "140%",
  },
  caption10Medium: {
    fontSize: "1rem",
    fontWeight: "400",
    lineHeight: "140%",
  },
} as const;

export const DESIGN_TOKEN_COLOR = {
  white: "#FFFFFF",
  themeBackground: {
    dark: "#212529",
    gray: "#F2F4F8",
    transparent: "transparent",
    default: "#FFFFFF",
  },
  shadow: {
    shadow100: "0px 4px 12px 0px rgba(6, 8, 12, 0.04)",
    shadow200: "0px 4px 8px 0px rgba(6, 8, 12, 0.12), 0px 1px 4px 0px rgba(6, 8, 12, 0.08)",
    shadow300: "0px 4px 12px 0px rgba(6, 8, 12, 0.12), 0px 4px 8px 0px rgba(6, 8, 12, 0.08)",
    shadow400: "0px 4px 12px 0px rgba(6, 8, 12, 0.22), 0px 4px 8px 0px rgba(6, 8, 12, 0.08)",
  },
  gray00: "#FFFFFF",
  gray100: "#F2F4F8",
  gray200: "#EDF0F4",
  gray300: "#DFE3EA",
  gray400: "#CED2DA",
  gray500: "#A9AFBB",
  gray600: "#8B909C",
  gray700: "#666B75",
  gray800: "#454952",
  gray900: "#212329",

  blue50: "#F1F6FF",
  blue100: "#E9F0FF",
  blue200: "#E2EBFE",
  blue300: "#C4D7FD",
  blue400: "#A7C4FC",
  blue500: "#89B0FB",
  blue600: "#6C9CFA",
  blue700: "#415E96",
  blue800: "#2B3E64",
  blue900: "#1C1A31",

  purple50: "#FBFAFF",
  purple100: "#F6F5FE",
  purple200: "#E8E6FD",
  purple300: "#D1CDFC",
  purple400: "#BAB3FA",
  purple500: "#A39AF9",
  purple600: "#8C81F7",
  purple700: "#544D94",
  purple800: "#383463",
  purple900: "#1C1A31",

  green100: "#E2FCF0",
  green200: "#C6F1DD",
  green300: "#A6E9C8",
  green400: "#6FDAA6",
  green500: "#28C07B",

  red100: "#FFE5E5",
  red200: "#FFC7C7",
  red300: "#FFA7A7",
  red400: "#FB5C5C",
  red500: "#F03E3E",

  orange100: "#FFF0CF",
  orange200: "#FDD495",
  orange300: "#FDB663",
  orange400: "#FC9F30",
  orange500: "#F58603",

  opacity4: "#06080C04",
  opacity8: "#06080C08",
  opacity12: "#06080C12",
  opacity22: "#06080C22",
  opacity32: "#06080C32",
  opacity48: "#06080C48",
  opacity56: "#06080C56",
  opacity72: "#06080C72",
  opacity86: "#06080C86",
  opacity100: "#06080C",
} as const;
